<template>
  <div class="flex flex-row rounded-full bg-primary-light text-sm uppercase tracking-wide relative">
    <div @mouseenter="show_image_for = option.name" @mouseleave="show_image_for = false"
         @click="$emit('input', option.name); show_image_for = false"
         v-for="option of options" :key="option.name"
         class="px-3 py-1 whitespace-no-wrap cursor-pointer select-none"
         :class="option.name == value ? `bg-${option.bg || 'primary'} text-${option.color || 'white'} font-bold rounded-full` : 'text-gray-600'">
      {{ $t(option.name) }}
      <div v-if="show_image_for == option.name && option.image"
           class="absolute rounded-lg border overflow-hidden w-64 z-10 shadow-lg"
           :style="{ top: 'calc(100% + 1rem)', right: '0' }">
        <img :src="option.image">
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        options: {
            default: () => [ { name: 'commons.yes', color: 'green-700', bg: 'green-200' }, { name: 'commons.no', color: 'red-700', bg: 'red-200' } ]
        },
        value: null,
    },
    data: () => ({
        show_image_for: false
    })
}
</script>